import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function DatabricksIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Box as="g" clipPath={`url(#databricks-a-${id})`}>
        <Box
          as="mask"
          id={`databricks-b-${id}`}
          width="20"
          height="20"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
          sx={{ maskType: "luminance" }}
        >
          <Box as="path" fill="#fff" d="M20 0H0v20h20V0Z" />
        </Box>
        <Box as="g" mask={`url(#databricks-b-${id})`}>
          <Box
            as="path"
            fill="#FF3621"
            d="M19.467 14.808v-3.541l-.392-.217-8.842 5.025-8.4-4.775V9.242l8.4 4.716 9.234-5.191V5.275l-.392-.217-8.842 5.025-8.05-4.575 8.05-4.55 6.5 3.675.492-.275V3.95L10.233 0 1 5.217v.516l9.233 5.209 8.4-4.742v2.075l-8.4 4.775-8.841-5.025L1 8.242v3.541l9.233 5.192 8.4-4.725v2.067l-8.4 4.775-8.841-5.025-.392.216v.525L10.233 20l9.234-5.192Z"
          />
        </Box>
      </Box>
      <Box as="defs">
        <clipPath id={`databricks-a-${id}`}>
          <Box as="path" fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </Box>
    </Icon>
  );
}
